<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  .inputs {
    position: sticky;
    bottom: 0;
    background: white;
    gap: utils.in_rem(8px);
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(8px) 0;

    .examples {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: utils.in_rem(8px);
      padding: 2px;
    }

    .search {
      width: 100%;
      display: flex;
      padding: 2px;
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import InputFieldCta from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/InputFieldCta.svelte";
  import { getContext } from "svelte";
  import { activityFeedStore, jobInfo } from "../../stores";
  import { CONTACT_AI_CONTEXT } from "./context";

  const { chatStore } = getContext(CONTACT_AI_CONTEXT);

  $: name = $jobInfo.candidateName;
  $: firstName = name.split(" ")[0] || "this contact";

  $: examples = name
    ? [
        `Suggest an icebreaker I can use with ${firstName}`,
        `Is ${firstName}'s company hiring?`,
        `What channel is ${firstName} most likely to reply on?`,
        "What did we last talk about?",
      ]
    : [];

  let value = "";

  const submit = () => {
    $chatStore = value;
    value = "";
  };

  const makeOnClick = (example) => () => {
    value = example;
    return submit();
  };

  const feedMeta = activityFeedStore.meta;
  $: disabled = $feedMeta.fetching;
  $: cls = disabled ? "disabled" : "";
</script>

<div class="inputs">
  <div class="examples">
    {#each examples as example}
      {@const onclick = makeOnClick(example)}
      <Button
        leadingIcon="fa-regular fa-sparkles"
        kind="ai-secondary"
        size="xs"
        {onclick}
        {disabled}
        class={cls}
      >
        {example}
      </Button>
    {/each}
  </div>
  <div class="search">
    <InputFieldCta
      onclick={submit}
      placeholder="Ask anything about this contact"
      bind:value
      allowMultiline={true}
    >
      <Button
        class={cls}
        size="small"
        kind="primary"
        leadingIcon="fa-regular fa-send"
        onclick={submit}
        {disabled}
      />
    </InputFieldCta>
  </div>
</div>
